<template>
  <div class="general-info">
    <div class="general-info__container">
      <div class="general-info__row general-info__align-items">
        <div v-if="showDynamicMenu" class="floating-menu">
          <DynamicMenu :menu-items="dynamicMenuItems" :current-slug="linksDepartment"/>
        </div>
        <div class="general-info__column">
          <div class="general-info__title"><h1 class="text-TTDrugs-Bold-40 color-green  text-uppercase">Центр медико-социальной поддержки женщин, оказавшихся в трудной жизненной ситуации</h1></div>
          <div class="general-info__index-mg">
            <AppSwiperDepartments :list_image="slides"/>
          </div>
        </div>
      </div>
      <div class="under-department-content">
        <div class="under-department-content__first-block">
          <p><span class="bold">Всех будущих мам волнует</span> вопрос: кем станет мой ребенок - будет он аутсайдером или победителем? Какой будет его жизнь – активной и наполненной яркими событиями или в «ожидании у моря погоды»?</p>
          <p>Научные исследования последних лет убедительно подтверждают <span class="bold">влияние перинатального опыта</span> на последующую жизнь человека. Плод имеет долговременную память, которая запечатлевает события, происходящие во время беременности и родов и эмоциональное состояние беременной мамы. Эта информация «хранится» в его памяти на протяжении всей последующей жизни, определяя стиль жизни и <span class="bold">способность найти свое «место под солнцем».</span></p>
          <p><span class="bold">Влияние эмоционального состояния женщины</span> на течение беременности, родов и, следовательно, на здоровье еще не родившегося ребенка, а также зависимость психического развития ребенка от психологических проблем его родителей, определяют важность работы перинатального психолога и специалиста по социальной работе с семьей, ожидающей рождения малыша.</p>
          <p><span class="bold">Спокойствие и уверенность матери в себе</span>, общение с близкими, дарящими будущему члену семьи заботу и внимание, <span class="bold">способствуют гармоничному формированию здорового ребенка.</span></p>
          <p><span class="bold">Работа психолога с родителями</span> по повышению родительской осознанности и ответственности, а также по развитию их личностных ресурсов, имеет важное значение в профилактике нарушений здоровья и поведения ребенка и сразу после его рождения, и в дальнейшем. Только <span class="bold">комплексный подход</span> к столь серьезному событию – рождению ребенка, может гарантировать благополучную беременность, <span class="bold">появление на свет здорового малыша, полноценное чувство радости и гармонии от материнства и отцовства.</span></p>
          <p>Кроме того, специалисты Центра координируют работу психологов и специалистов по социальной работе районных медицинских учреждений и активно помогают коллегам на местах в оказании помощи и поддержки женщинам, планирующим беременность или находящимся в ситуации репродуктивного выбора.</p>
        </div>
        <div class="under-department-content__second-block">
          <div class="under-department-content__second-block-image">
            <img src="../../assets/img/departments/support/support5.jpg" alt="Центр поддержки" class="under-department-content__image" />
          </div>
          <div class="under-department-content__second-block-text">
         <AppTest/>
          </div>
        </div>
      </div>
      <div class="general-info-department">

        <div class="general-info-department__info-block">
          <div class="general-info-department__title-left">
            <p class="text-TTDrugs-Bold-40 color-green center text-uppercase">Специалисты</p>
          </div>
        </div>
        <div class="general-info-department__thank">
          <BlockThankYou/>
        </div>
      </div>
      <AppDoctorsPeopleList :people_list="doctors"/>
    </div>
    <div class="general-info-article-under-department">
      <app-article-departments-list :name_department="linksDepartment" />
    </div>
  </div>


</template>
<script>
import BlockThankYou from '@/components/BlockThankYou.vue'
import AppSwiperDepartments from '@/components/Gallery/SwiperDepartments.vue'
import {actionTypesDepartment} from '@/store/modules/department'
import {mapState} from 'vuex'
import AppTest from '@/components/TestOne.vue'
import AppArticleDepartmentsList from '@/components/Article/ArticleDepartmentsList.vue'
import AppDoctorsPeopleList from '@/components/People/DoctorsPeopleList.vue'
import DynamicMenu from "@/components/DynamicMenu.vue";
import menuItemsApi from "@/api/menuItems";

export default {
    name: "AppSupportCenter",
    components: {DynamicMenu, AppDoctorsPeopleList, AppArticleDepartmentsList, AppTest, AppSwiperDepartments, BlockThankYou},
    metaInfo() {
      return {
        title: 'Центр поддержки | Алтайский краевой клинический перинатальный центр ДАР',
        meta: [
          {
            name: 'description',
            content: 'Отделения Алтайского краевого клинического перинатального центра ДАР. Центр поддержки. Подготовьтесь к родам вместе с Алтайским краевым клиническим перинатальным центром ДАР.'
          },
          {
            name: 'keywords',
            content: ' центр поддержки, роды, сопровождение родов, родильный дом, партнерские роды, послеродовой уход, перинатальный центр ДАР'
          }
        ]
      };
    },
    data() {
      return {
        nameDepartment: 'Центр поддержки',
        linksDepartment: 'department/support-center',
        dynamicMenuItems: [],
        slides: [
          { id: 1, image: require('../../assets/img/departments/support/support.jpg') },
          { id: 2, image: require('../../assets/img/departments/support/support1.jpg') },
          { id: 3, image: require('../../assets/img/departments/support/support2.jpg') },
          { id: 4, image: require('../../assets/img/departments/support/support3.jpg') },
          { id: 5, image: require('../../assets/img/departments/support/support4.jpg') },
          { id: 6, image: require('../../assets/img/departments/support/support5.jpg') },
          { id: 7, image: require('../../assets/img/departments/support/support6.jpg') },
        ]
      }
    },
    computed: {
      ...mapState({
        underDepartments: (state) => state.department.underDepartments,
        selectedDepartmentId: (state) => state.department.selectedDepartmentId,
        doctors: (state) => state.department.doctors
      }),
      showDynamicMenu() {
        return this.dynamicMenuItems && this.dynamicMenuItems.length > 0;
      }
    },
    methods: {
      async loadSiblingsForMenu() {
        try {
          const response = await menuItemsApi.getSiblingsByTo('/department/support-center');

          if (response.data.status === "SUCCESS") {
            this.dynamicMenuItems = response.data.result
                .map(item => {
                  const slug = item.to.startsWith('/') ? item.to.substring(1) : item.to;

                  return {
                    text: item.label,
                    link: item.to,
                    slug: slug,
                    active: slug === this.currentPath,
                    id: item.id,
                    order: item.order || 0
                  };
                })
                .sort((a, b) => (a.order || 0) - (b.order || 0));
          }
        } catch (error) {
          console.error('Ошибка при загрузке меню:', error);
        }
      },
      fetchArticleDepartment() {
        this.$store.dispatch(actionTypesDepartment.getArticleDepartment, this.nameDepartment)
            .then(() => {
            })
            .catch((er) => {
              console.log("Ошибка", er);
            });
      },
      getDoctorsDepartment() {
        this.$store.dispatch(actionTypesDepartment.getDoctorsDepartment, this.nameDepartment)
            .then(() => {
            })
            .catch((er) => {
              console.log("Ошибка", er);
            });
      }

    },
    mounted() {
      this.fetchArticleDepartment();
      this.getDoctorsDepartment();
      this.loadSiblingsForMenu();
    }
  };
</script>

